import { track, trackingEvents } from 'modules/core/lib/Tracking'

const trackAddRestDayPlanningUserProfileStart = (checkboxStatus: boolean) => {
  track(trackingEvents.timePlanning.addRestDayPlanningUserProfileStart, {
    checkbox_status: checkboxStatus,
  })
}

const trackEditPlanningVersionStart = (
  planningTool: string,
  restDays: number | undefined,
  workSchedule: string | undefined
) => {
  track(trackingEvents.timePlanning.editPlanningVersionStart, {
    planning_tool: planningTool,
    rest_days: restDays,
    workschedule: workSchedule,
  })
}

const trackEditPlanningVersionSubmit = (
  oldPlanningTool: string,
  newPlanningTool: string,
  restDays: number | undefined,
  workSchedule: string | undefined
) => {
  track(trackingEvents.timePlanning.editPlanningVersionSubmit, {
    old_planning_tool: oldPlanningTool,
    new_planning_tool: newPlanningTool,
    new_planning_version_rest_days: restDays,
    new_planning_version_workschedule: workSchedule,
  })
}

const trackAddNewPlanningVersionStart = (from: string) => {
  track(trackingEvents.timePlanning.addNewPlanningVersionStart, {
    from: from,
  })
}

const trackAddNewPlanningVersionSubmit = (
  planningTool: string,
  effectiveDate: string,
  restDays: number | undefined,
  workSchedule: string | undefined
) => {
  track(trackingEvents.timePlanning.addNewPlanningVersionSubmit, {
    planning_tool: planningTool,
    effective_date: effectiveDate,
    new_planning_version_rest_days: restDays,
    new_planning_version_workschedule: workSchedule,
  })
}

export {
  trackAddNewPlanningVersionStart,
  trackAddNewPlanningVersionSubmit,
  trackAddRestDayPlanningUserProfileStart,
  trackEditPlanningVersionStart,
  trackEditPlanningVersionSubmit,
}
